import { useMemo } from "react";

import useTableSort from "components/Table/useTableSort";

import {
  INITIAL_SORT_DIRECTION,
  INITIAL_SORT_OPTION,
  MODULE_WEBHOOKS_TABLE_FILTERS_STORAGE_KEY,
  SORT_CONFIG,
} from "./constants";
import { sortModuleWebhooks } from "./helpers";
import { WebhookIntegrationWithTimestamp } from "./types";

export const useSortingModuleWebhooks = (webhooks: WebhookIntegrationWithTimestamp[]) => {
  const { sortDescriptor } = useTableSort({
    filtersOrderSettingsKey: MODULE_WEBHOOKS_TABLE_FILTERS_STORAGE_KEY,
    sortConfig: SORT_CONFIG,
    initialSortOption: INITIAL_SORT_OPTION,
    initialSortDirection: INITIAL_SORT_DIRECTION,
  });

  return useMemo(() => sortModuleWebhooks(webhooks, sortDescriptor), [webhooks, sortDescriptor]);
};
